import { includes } from 'lodash'

export const SUCCESS_STATUS = 'OK'
export const RESULT_TYPE_LOCALITY = 'locality'
export const RESULT_TYPE_POSTAL_CODE = 'postal_code'

export const getCityLocationFromReverseLookup = (latitude, longitude) => {
  const location = { lat: latitude, lng: longitude }
  const geocoder = new window.google.maps.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.geocode({ location }, (results, status) => {
      if (status === SUCCESS_STATUS) {
        let zipcode
        let location
        // Get zipcode
        const addressComponents = results[0].address_components
        for (const component of addressComponents) {
          if (includes(component.types, RESULT_TYPE_POSTAL_CODE)) {
            zipcode = component.long_name
            break
          }
        }
        // Get actual formatted address
        for (const result of results) {
          if (includes(result.types, RESULT_TYPE_LOCALITY)) {
            location = result.formatted_address
            break
          }
        }
        return resolve({ location, zipcode })
      }
      return reject(
        new Error(
          `Could not retrieve reverse lookup result for ${latitude}, ${longitude}, the reason is : ` +
            status
        )
      )
    })
  })
}

export const getGeoInfoFromReverseLookup = address => {
  const geocoder = new window.google.maps.Geocoder()
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address }, (results, status) => {
      if (status === SUCCESS_STATUS) {
        const geoInfo = results[0].address_components
        return resolve({ geoInfo })
      }
      return reject(
        new Error(
          `Could not retrieve reverse lookup result for ${address}, the reason is : ` +
            status
        )
      )
    })
  })
}
